import Script from 'next/script';

//* https://ouraringconfig.com/sdk/9.min.js Affiliate LP skinning tech for CP */
const AffiliatesScript = () => (
  <Script
    async
    src="https://ouraringconfig.com/sdk/9.min.js"
    strategy="afterInteractive"
  />
);

export default AffiliatesScript;
